import React, { useEffect } from 'react';
import { useIntl } from '@@/plugin-locale/localeExports';
import { Notification, Page, Utils } from '@gov-mo/mpaas-js-bridge';
import { isMobile } from '@/utils';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import styles from './css/Detail.module.less';

const Faceauthb: React.FC = () => {
  const intl = useIntl();
  // 獲取參數
  const urlParams = new URLSearchParams(window.location.search);
  console.log(urlParams);
  const error = urlParams.get('error');
  const isSuccess = (error === '' || error === undefined || error == null);
  // 請求數據
  useEffect(() => {
    // 成功或失敗結果
    // 判斷是手機還是PC  頁面停頓一秒後響應
    const timeout = isSuccess ? 1000 : 3000000;
    if (Utils.isGovMoApp()) {
      // APP
      setTimeout(() => {
        Notification.sendEvent('identity-auth', { success: isSuccess });
        Notification.sendEvent('close-identity-begin-page');
        Page.close();
      }, timeout);
    } else {
      // PC
      setTimeout(() => {
        window.opener?.postMessage(
          {
            type: 'identity-auth',
            success: isSuccess,
          },
          window.location.origin,
        );
        window.close();
      }, timeout);
    }
  }, []);

  if (isSuccess) {
    return (
      <div className={`${styles.root} ${!isMobile() ? styles['web-root'] : ''}`}>
        <div className={styles.success}>
          <CheckOutlined />
        </div>
        <p>{intl.formatMessage({ id: '身份識別成功' })}</p>
      </div>
    );
  }
  return (
    <div className={`${styles.root} ${!isMobile() ? styles['web-root'] : ''}`}>
      <div className={styles.fail}>
        <CloseOutlined />
      </div>
      <p>{intl.formatMessage({ id: '身份識別失敗' })}</p>
      <p>{error && ` ${error}`}</p>
    </div>
  );
};

export default Faceauthb;
